


































import Vue from 'vue'
import { RelatedLink } from '@/common/types/index'

const MAX_DEFAULT_LINKS = 5

export default Vue.extend({
  props: {
    title: {
      type: String,
      required: true
    },
    links: {
      type: Array as () => RelatedLink[],
      default: () => []
    },
    maxDefaultLinks: {
      type: Number,
      default: MAX_DEFAULT_LINKS
    }
  },
  data(): {
    isExpanded: boolean,
  } {
    return {
      isExpanded: false
    }
  },
  computed: {
    visibleNumber(): number {
      const linksLength = this.links.length
      return linksLength <= this.maxDefaultLinks ? linksLength : (this.isExpanded ? linksLength : this.maxDefaultLinks)
    },
    expandVisible(): boolean {
      return this.links.length > this.maxDefaultLinks
    }
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    }
  }
})
